/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/CustomIdentifierSet/ExperimentWorkflow
 * @desc Action to set CustomIdentifierSet for ExperimentWorkflows
 */

import { CustomIdentifierSetActionCreate } from 'labstep-web/components/CustomIdentifierSet/Action/Create';
import { CustomIdentifierSetPreview } from 'labstep-web/components/CustomIdentifierSet/Preview';
import { useHasAccessCreate } from 'labstep-web/components/Entity/Can/hooks';
import { TextPlaceholder } from 'labstep-web/core/Text/Placeholder';
import { CustomIdentifierSet } from 'labstep-web/models/custom-identifier-set.model';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { GroupFormShowEditCustomShowIdentifierSetExperimentWorkflowProps } from './types';

export const GroupFormShowEditCustomShowIdentifierSetExperimentWorkflow: React.FC<
  GroupFormShowEditCustomShowIdentifierSetExperimentWorkflowProps
> = ({ group }) => {
  const canCreate = useHasAccessCreate(
    CustomIdentifierSet.entityName,
  ) as boolean;

  const customIdentifierSet =
    group.experimentWorkflowCustomIdentifierSet;
  if (customIdentifierSet) {
    return (
      <CustomIdentifierSetPreview
        customIdentifierSet={customIdentifierSet}
        canCreate={canCreate}
      />
    );
  }
  if (canCreate) {
    return (
      <CustomIdentifierSetActionCreate
        groupId={group.id}
        parentClass={ExperimentWorkflow.entityName}
      />
    );
  }
  return <TextPlaceholder>No Custom Identifier</TextPlaceholder>;
};
